import { Component, OnInit, OnDestroy, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from '@angular/common';
import { UserService} from '@shared/services/user/user.service';
import { PowerBIReports } from '@app/auth/store/auth.interface';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-pbi-report',
    templateUrl: 'pbi-report.component.html',
    styleUrls: ['pbi-report.component.scss'],
    standalone: false
})
export class PbiReportComponent implements OnInit, OnDestroy {
  private destroyRef = inject(DestroyRef);

  public campaignAnalyticsRoute = '/report/Phishing-Campaign';
  public resilienceRoute = '/report/Resilience';
  public phishingTrendsRoute = '/report/Phishing-Trends';
  public reportsData: PowerBIReports;
  public reportsDataLoaded = false;
  public blastPurchased = this.userService.userData.selected_customer.purchased_services.blast.purchased;
  public warningMessage: string;
  public reportsViewType: number;
  public chartsMessage: string;

  constructor(public router: Router,
              private title: Title,
              public route: ActivatedRoute,
              public userService: UserService) { }

  ngOnInit() {
    if (this.router.url == '/report/Resilience') {
      this.router.navigate(['/dashboard']);
    }

     if (this.userService.desktopPages.length > 0 && !this.userService.pbiInitialized) {
       let pageName = null;
       const pages = this.userService.desktopPages.filter( p => p.childRoute === this.route.snapshot.params['type']);
       if (pages.length > 0) {
         pageName = pages[0].name;
       }
       this.userService.initializePbi({pageName: pageName});
    }
     this.userService.reportsData.pipe(
       filter(data => !!data),
       takeUntilDestroyed(this.destroyRef))
       .subscribe((data) => {
       this.reportsData = {...data};
       this.reportsDataLoaded = true;
       this.displayMockOrRealData();
         // The customer has not uploaded targets:
       if (!this.reportsData.customer_has_uploaded_targets) {
         this.warningMessage = 'Upload your employee list and complete the onboarding process before running your first campaign';
         this.reportsViewType = 1;
         this.chartsMessage = 'Data will appear once the first campaign starts running';
         // The customer has uploaded targets but has not activated the first campaign.
       } else if (!this.reportsData.first_campaign_activated) {
         this.warningMessage = 'Activate your first campaign and start training employees';
         this.reportsViewType = 2;
         this.chartsMessage = 'Data will appear once the first campaign starts running';
         // The customer has uploaded targets and has activated the first campaign, but the campaign has not started running
       } else if (!this.reportsData.first_campaign_running) {
         const date = this.reportsData?.details?.date ?
           `${formatDate(this.reportsData.details.date,'MMM, dd YYYY', 'en_US')}` :
           'the next training day';
         this.warningMessage = `Your campaign has been activated and will start running on ${date}`;
         this.reportsViewType = 3;
         this.chartsMessage = 'Data will appear once the first campaign starts running';
         // The customer has uploaded targets and has activated the first campaign, the first attack has been sent but 6 hours have not passed yet. After 6 hours the mock is removed.
       } else if (!this.reportsData.first_campaign_passed_six_hours) {
         this.warningMessage = 'Phishing simulation delivery has begun. Data will appear within the next 6 hours';
         this.reportsViewType = 4;
         this.chartsMessage = 'Data will appear within the next six hours';
       }
       if (!this.userService.userData.selected_customer.purchased_services.blast.purchased) {
         this.warningMessage = 'This page is available for BLAST customers only, contact your customer success manager for more information';
         this.reportsViewType = 5;
         this.chartsMessage = '';
       }
     });

    this.route.params.subscribe(params => {
      if (this.userService.pbiReport) {
        const page = this.userService.userData.selected_customer.report_pages
          .filter(p => p.childRoute === params['type'])
          .pop();
        this.userService.pbiReport.setPage(page.name);
        this.title.setTitle(`${page.displayName} - CybeReady`);
        this.displayMockOrRealData();
      }
    });

  }

  displayMockOrRealData() {
    document.getElementById('pbi-el').style.display = 'block';
    const noDataMockPagesAvailable = [this.resilienceRoute, this.phishingTrendsRoute, this.campaignAnalyticsRoute].includes(this.router.url);
    if (!this.reportsData.real_sent_attacks_exist && noDataMockPagesAvailable) {
      document.getElementById('pbi-el').style.display = 'none';
    }
  }

  ngOnDestroy() {
    document.getElementById('pbi-el').style.display = 'none';
  }

}
